import React from 'react'
import { Tag } from 'antd'
import { CheckCircleOutlined } from '@ant-design/icons'
import moment from 'moment'
import { apiToReadable } from '../../../common/utils/helpers'

const GseSubmissionBadge = ({ submission }) => {
  const investorName = apiToReadable(submission.type)
  const submissionDate = moment(submission.created).format('MM/DD/YYYY HH:mm')

  return (
    <Tag
      color="success"
      icon={<CheckCircleOutlined />}
      style={{ marginBottom: '8px' }}
      data-testid="gse-submission-badge"
    >
      {investorName} - {submissionDate}
    </Tag>
  )
}

export default GseSubmissionBadge
